module.exports = __webpack_public_path__ + "static/media/voln.49d1e3bb.svg";